import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import FormPreview from './FormMasterPreview'; // Assuming this is your form rendering component
import api from '../../api/axiosInstance';
const FormPreviewPage = () => {debugger;
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get the query parameters from URL
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const recordGuidStr = queryParams.get('recordGuidStr'); // Fetch 'recordGuidStr' from URL query params
  const userData = JSON.parse(localStorage.getItem('user')); // Get user info from localStorage
  const loggedinUserid = userData ? userData.email : null; // Get logged-in user email

  useEffect(() => {
    // Function to fetch form data from the backend
    const fetchFormData = async () => {
      try {
        setLoading(true); // Set loading state to true before making the request
        const response = await api.get(`/FormMaster/PreviewFormMaster`, {
          params: {
            recordGuidStr,
            loggedinUserid
          }
        });

        if (response.status === 200) {debugger;
          setFormData(response.data); // Store the form data if the request is successful
        } else {debugger;
          setError('Failed to fetch form data. Please try again.'); // Set error message if status is not 200
        }
      } catch (err) {debugger;
        // Handle any errors during the request
        if (err.response) {debugger;
          setError(`Error: ${err.response.data || 'Unknown error from server'}`);
        } else if (err.request) {debugger;
          setError('No response received from the server. Please check your connection.');
        } else {debugger;
          setError('Error fetching form data.');
        }
      } finally {
        setLoading(false); // Stop loading state after the request completes
      }
    };

    // Only fetch data if 'recordGuidStr' and 'loggedinUserid' are available
    if (recordGuidStr && loggedinUserid) {
      fetchFormData();
    }
  }, [recordGuidStr, loggedinUserid]); // Dependency array to trigger fetch when either 'recordGuidStr' or 'loggedinUserid' changes

  // Display loading state with custom styling
  if (loading) {
    return (
      <div style={{ color: 'blue', fontFamily: 'Arial, sans-serif', fontSize: '20px' }}>
        Loading...
      </div>
    );
  }

  // Display error state with custom styling
  if (error) {
    return (
      <div style={{ color: 'red', fontFamily: 'Arial, sans-serif', fontSize: '18px' }}>
        {error}
      </div>
    );
  }

  // Render the form data if fetched successfully
  return (
    <div>
      {formData ? (
        <FormPreview formData={formData} /> // Pass formData to the FormPreview component for rendering
      ) : (
        <div>No form data available.</div> // Message if no data is available
      )}
    </div>
  );
};

export default FormPreviewPage;
